module.exports = __webpack_public_path__ + "img/C06TechResourcefulness_ua.0a8c88c9.webp";